module.exports = __webpack_public_path__ + "img/product.e3aec182.png";